export const UNTRIAGED_CASE_COUNT_EVENT = 'fold:untriaged-case-count-updated';

export function publishUntriagedCaseCount(count, target = window) {
  const numericCount = Number(count);
  const untriagedCaseCount = Number.isFinite(numericCount)
    ? Math.max(0, numericCount)
    : 0;

  target.dispatchEvent(new CustomEvent(UNTRIAGED_CASE_COUNT_EVENT, {
    detail: { untriagedCaseCount },
  }));
}

export function subscribeToUntriagedCaseCount(listener, target = window) {
  const handleCountUpdate = (event) => {
    listener(event.detail?.untriagedCaseCount ?? 0);
  };

  target.addEventListener(UNTRIAGED_CASE_COUNT_EVENT, handleCountUpdate);
  return () => target.removeEventListener(UNTRIAGED_CASE_COUNT_EVENT, handleCountUpdate);
}
